import { useState } from 'react';
import moment from 'moment';

export const useCustomInputPresenter = ({ innerValue, onChange, onChangeInput, onBlurInput }) => {
  const [isFocused, setIsFocused] = useState(false);

  const presenter = {
    isFocused,
    setIsFocused,

    get localValue() {
      return isFocused && !innerValue ? 'дд.мм.гггг' : innerValue;
    },

    changeHandler(value) {
      onChangeInput(value);
      const momentDate = moment(value, 'DDMMYYYY');
      if (value.length === 8 && momentDate.isValid()) {
        onChange({ target: { value: momentDate.format('DD.MM.YYYY') } });
      }
    },

    focusHandler() {
      setIsFocused(true);
    },

    blurHandler() {
      setIsFocused(false);
      onBlurInput(innerValue);
    },
  };

  return presenter;
};
